import React from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";
import _capitalize from "lodash/capitalize";

class CaseActionModals extends React.Component {
    state = {
        modalVisible:false,
        caseId: null,
        action: null
    }
    componentDidMount() {
        this.registerListener();

    }
    toggleModal = (caseId=null, action=null) => {
        this.setState({
            caseId,
            action,
            modalVisible: !this.state.modalVisible
        });
    }
    registerListener() {
        this.props.listenerHandler(this.toggleModal);
    }
    onCaseActionComplete() {

    }
    getModalBody() {
        const { action } = this.state;
        if(this.props.config && this.props.config.size > 0) {
            const actionConfig = this.props.config.get(action);
            this.formRef = React.formRef();
            return React.createElement(actionConfig.Comp, {

            });
        }
    }
    render(){
        return (<React.Fragment>
            <Modal
                title={this.state.action && _capitalize(this.state.action)}
                visible={this.state.modalVisible}
                onOk={this.onCaseActionComplete}
                onCancel={this.toggleModal}>
                {this.getModalBody()}
            </Modal>
        </React.Fragment>);
    }
}

CaseActionModals.propTypes = {
    listenerHandler: PropTypes.func,
    config: PropTypes.object
};


export default CaseActionModals;